import TagArrayInputField from "@/components/forms/TagArrayInputField.tsx";
import CollapsibleFormSection from "@/components/forms/CollapsibleFormSection.tsx";
import {useFormContext, useWatch} from "react-hook-form";
import {CharacterFormInput} from "@/characters/admin/form/CharacterFormSchema.ts";

export default function CharacterDamageModifiersForm() {
    const {control, formState: {errors}} = useFormContext<CharacterFormInput>();
    const [resistances, immunities, conditionImmunities, vulnerabilities] = useWatch({
        control,
        name: ["damageResistances", "damageImmunitys", "conditionImmunitys", "damageVulnerabilitys"],
    });
    const count = resistances.length + immunities.length + conditionImmunities.length + vulnerabilities.length;
    const hasErrors = Boolean(errors.damageResistances || errors.damageImmunitys ||
        errors.conditionImmunitys || errors.damageVulnerabilitys);

    return <CollapsibleFormSection title="Resistenzen & Immunitäten"
                                   summary={count === 0 ? "Keine Einträge" : `${count} Einträge`}
                                   forceOpen={hasErrors}
                                   contentClassName="grid gap-3 md:grid-cols-2">
        <TagArrayInputField name="damageResistances" title="Schadensresistenzen"/>
        <TagArrayInputField name="damageImmunitys" title="Schadensimmunitäten"/>
        <TagArrayInputField name="conditionImmunitys" title="Zustandsimmunitäten"/>
        <TagArrayInputField name="damageVulnerabilitys" title="Schadensverwundbarkeiten"/>
    </CollapsibleFormSection>;
}
